import clsx from 'clsx';

import { twMerge } from '@polyai/ui/utils/twMerge';

import { DRAG_HANDLE_CLASS } from 'screens/FlowDetails/constants';

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

export const DragHandle = ({ className, ...props }: Props) => {
  const klass = twMerge(
    clsx(`absolute z-[1] inset-0 ${DRAG_HANDLE_CLASS}`, className),
  );
  return <div className={klass} {...props} />;
};
